module.exports = __webpack_public_path__ + "static/dusk-and-gear-b8b67f139ecc2b7338f1e4af0adf24bd.jpg";